module.exports = __webpack_public_path__ + "static/media/favicon.4180771d.ico";